<template>
  <div class="RemindSetting">
    <van-cell center title="接收消息通知" :label="notificationAuthorized ? '已开启消息通知' : '关闭消息通知，将无法通过APP接收抢购提醒等消息'" size="large">
      <template #right-icon>
        <van-switch :value="notificationAuthorized" size="24px" @input="onInput" />
      </template>
    </van-cell>
  </div>
</template>

<script>
import { Cell, Switch } from 'vant'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    'van-cell': Cell,
    'van-switch': Switch
  },
  computed: {
    ...mapGetters(['notificationAuthorized'])
  },
  mounted() {
    this.updateNotificationAuthorized()
  },
  methods: {
    ...mapActions(['updateNotificationAuthorized', 'openAppAuthorizeSetting']),
    onInput() {
      this.openAppAuthorizeSetting()
    }
  }
}
</script>

<style lang="scss">
.RemindSetting {
  border-bottom: 1px solid #ebedf0;
  box-sizing: border-box;
}
</style>
